import { ADMIN_PROPTECHS, } from "../../../constants/APIs"
import { Actions } from "../../../store/actions"
import { ADMIN_API } from "../../../utils/utility/API-call"
import { dispatch } from "../../../utils/utility/store"
import { handleError, handleSuccess, } from "../../../utils/utility/snackbar"
import { numbersTabDTO } from "../dtos/numbersTab"
import { getGrossMarginData, getGrowthBlockersData, getNoOfCountriesData, getNoOfCustomersData } from "../dropdowns"

export const loadNumbersTabData = (id, adminAnalysisTab, adminDropdowns, radarDetails) => {
  if (!adminAnalysisTab.numbersTabData) {
    getNumbersDetails(id)
  }
  if (!radarDetails?.numbersRadar) {
    getTrackRecordRadarDetails()
  }
  loadNumbersTabDropdowns(adminDropdowns.noOfCustomers, adminDropdowns.noOfCountries, adminDropdowns.grossMargins, adminDropdowns.growthBlockers)
}

export const getNumbersDetails = (id) => {
  dispatch(Actions.AdminUser.SetLoading, true)
  ADMIN_API().get(ADMIN_PROPTECHS + `/${id}/numbers`)
    .then(res => {
      dispatch(Actions.AdminUser.SetLoading, false)
      dispatch(Actions.AdminAnalysisTab.SetNumbersTabData, numbersTabDTO(res.data.data))
      handleSuccess(res)
    }).catch(err => {
      dispatch(Actions.AdminUser.SetLoading, false)
      handleError(err)
    })
}

export const updateNumbersDetails = (id, data, radars) => {
  if(radars?.length) {
    data['placeRadarPoints'] = radars?.map(i => ({radarId: i.id, value: i.value}))
  }
  dispatch(Actions.AdminUser.SetLoading, true)
  return ADMIN_API().put(ADMIN_PROPTECHS + `/${id}/numbers`, data)
    .then(res => {
      handleSuccess(res)
      getNumbersDetails(id)
      return res?.status;
    }).catch(err => {
      dispatch(Actions.AdminUser.SetLoading, false)
      handleError(err);
      return err?.response?.status;
    })
}

//number tab radar
export const getTrackRecordRadarDetails = () => {
  dispatch(Actions.AdminUser.SetLoading, true)
  ADMIN_API().get(ADMIN_PROPTECHS + `/radar/track_record`)
    .then(res => {
      dispatch(Actions.AdminUser.SetLoading, false)
      dispatch(Actions.AdminAnalysisTab.SetRadarDetails, { numbersRadar: res.data.data })
      handleSuccess(res)
    }).catch(err => {
      dispatch(Actions.AdminUser.SetLoading, false)
      handleError(err)
    })
}

export const loadNumbersTabDropdowns = (noOfCustomers, noOfCountries, grossMargins, growthBlockers) => {
  if (!noOfCustomers.length) {
    getNoOfCustomersData();
  }
  if (!noOfCountries.length) {
    getNoOfCountriesData();
  }
  if (!grossMargins.length) {
    getGrossMarginData();
  }
  if (!growthBlockers.length) {
    getGrowthBlockersData();
  }
}